import { getFirebaseAuthToken } from './firebase'

export const apiFetch = async (
  path: string,
  options: RequestInit & { withCredentials?: boolean } = {}
) => {
  const { withCredentials = false, ...restOptions } = options
  const API_URL = import.meta.env.VITE_BACKEND_URL
  const headers: HeadersInit = {
    'Content-Type': 'application/json'
  }

  if (withCredentials) {
    const authToken = await getFirebaseAuthToken()
    headers.Authorization = `Bearer ${authToken}`
  }

  const response = await fetch(`${API_URL}${path}`, {
    credentials: 'include',
    headers,
    ...restOptions
  })

  return response
}
